import { ApiService } from '../shared/services/api-service/api.service';
import { IGlobalsCountriesResponse, ICurrencyExchangeRates } from './interfaces/globals.interfaces';

/**
 * @ignore
 */
declare const TCCommonService;

/**
 * Globals Service
 */
class GlobalsServiceClass {
    /**
     * Method to get countries
     * @memberof GlobalsServiceClass
     */
    async getCountries() {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_globals_countries';
        const globalsCountriesFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({ key: cacheKey });
        if (globalsCountriesFromCache) {
            return globalsCountriesFromCache;
        }
        try {
            const globalsCountriesApiResponse: Response = await ApiService.getCountries();
            const globalsCountries: IGlobalsCountriesResponse = await globalsCountriesApiResponse.json();
            TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: globalsCountries });
            return globalsCountries;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

    /**
     * Method to get exchange rates of a currency
     * @param baseCurrencyCode
     * @returns
     */
    async getCurrencyExchangeRates(baseCurrencyCode: string) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_globals_currency_exchange_rates_' +
            baseCurrencyCode.toLowerCase();
        const currencyExchangeRatesFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({ key: cacheKey });
        if (currencyExchangeRatesFromCache) {
            return currencyExchangeRatesFromCache;
        }
        try {
            const currencyExchangeRatesApiResponse: Response = await ApiService.getCurrencyExchangeRates(baseCurrencyCode);
            const currencyExchangeRates: ICurrencyExchangeRates = await currencyExchangeRatesApiResponse.json();
            TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: currencyExchangeRates });
            return currencyExchangeRates;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const GlobalsService = new GlobalsServiceClass();
